import React from "react";
import { Box, Rating, Typography } from "@mui/material";

export function ReviewsTab({ provider }) {
    const reviews = provider?.reviews || [];
    return <Box sx={{ p: '5px', pb: '25px' }}>
            <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>Reviews</Typography>
            <Box id="tab">
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                    <Typography>{provider?.rating?.toFixed(1) || "0.0"}</Typography>
                    <Rating value={provider?.rating || 0} precision={0.5} readOnly />
                    <Typography>({reviews.length})</Typography>
                </Box>
                {reviews.length === 0 && <Typography>No reviews yet.</Typography>}
                {reviews.slice().sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map((review) => (
                    <Box key={review.id} sx={{ mb: 2, p: 2, border: "1px solid #ddd", borderRadius: 1 }}>
                        <Rating value={review.stars} readOnly />
                        <Typography fontWeight={600}>{review.reviewerName || "Anonymous"}</Typography>
                        {review.comment && <Typography>{review.comment}</Typography>}
                        {review.createdAt && <Typography fontSize={12} color="text.secondary">{new Date(review.createdAt).toLocaleDateString()}</Typography>}
                    </Box>
                ))}
            </Box>
    </Box>;
}


